import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { CommonTemplate } from '../api-types/document.api';

export interface DocumentFile {
	id: string;
	name: string;
	location: string;
	mimeType: string;
	size: number;
	isFrozen?: boolean;
	createdAt?: Date;
}

export enum DocumentFileSubjectType {
	GLOBAL = 0,
	USER = 1,
	DISABILITY_REPORT = 2, //Behinderungs Nachweis
	DISABILITY_KIND = 3, //Behinderungs Art
	CONTACT = 4,
	ASSIGNMENT = 5,
}

export enum DOCUMENT_CATEGORY {
	DISABILITY_REPORT = 'DisabilityReport',
	DISABILITY_KIND = 'DisabilityKind',
	CONTACT = 'Contact',
	ASSIGNMENT = 'Assignment',
	REPORT = 'Report',
	UNKNOWN = 'Unknown',
}
export interface DocumentEntry {
	id: number;
	name: string;
	category: DOCUMENT_CATEGORY;
	createdAt: Date;
	externalFileReference: DocumentFile[];
	isReport: boolean;
	isFrozen: boolean;
	assignmentId?: number;
	reportTypeId?: number;
}

export interface ClientDocumentsResponse {
	commonEntries: CommonTemplate[];
	entries: PaginatedResponse<DocumentEntry>;
}

export interface DocumentNavItem {
	file: DocumentFile;
	entryId: number;
	entryName: string;
	category: DOCUMENT_CATEGORY;
	createdAt: Date;
	isReport: boolean;
	isFrozen: boolean;
}
